import { useState } from 'react';
import { useReadContract } from 'wagmi';
import ScrollStatKey from '../../assets/abis/ScrollStatKey.json'; // ABI of your contract

const contractAddress = process.env.REACT_APP_COLLECTION_ADDRESS; // Address of your contract

export const useCurrentTier = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'getCurrentTier',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTotalMinted = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'getTotalMinted',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useRemainingSupply = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'getRemainingSupply',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useWithdrawableAmount = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'getWithdrawableAmount',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier1 = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier1Price',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier2 = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier2Price',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier3 = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier3Price',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};


export const useMaxSupply = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'MAX_SUPPLY',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier1Supply = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'TIER_1_LIMIT',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier2Supply = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'TIER_2_LIMIT',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier1Minted = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier1Minted',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier2Minted = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier2Minted',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useTier3Minted = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'tier3Minted',
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};

export const useImageURI = () => {
	const [refreshKey, setRefreshKey] = useState(0);

	const refetch = () => {
		setRefreshKey(prev => prev + 1);
	};

	const result = useReadContract({
		address: contractAddress,
		abi: ScrollStatKey.abi,
		functionName: 'uri',
		args: [0],
		watch: true,
		enabled: !!contractAddress,
		key: refreshKey,
	});

	return { ...result, refetch };
};
